const constants = {
    CANADIAN_FRENCH: 'fr-CA',
    DEFAULT: 'en',
    ENGLISH: 'en',
    FRANCE_FRENCH: 'fr-FR',
    FRENCH: 'fr',
    SWISS_FRENCH: 'fr-CH',
}

export default constants
